import React from "react";

interface DiscoverIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const DiscoverIcon: React.FC<DiscoverIconProps> = ({
  width = 24,
  height = 24,
  fill = "currentColor",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM15.35 8.65L14 14L8.65 15.35L10 10L15.35 8.65ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
        fill={fill}
      />
    </svg>
  );
};

export default DiscoverIcon;
